<template>
<b-container fluid>
<b-row>
<b-col offset-xl="3" xl="6"> 
  <b-card body-class="p-0" header-class="border-0">
    <template v-slot:header>
      <b-row align-v="center">
        <b-col>
          <h3 class="mb-0">Adjustments</h3>
        </b-col>
      </b-row>
    </template>

    <el-table
      class="table-responsive table"
      :data="getAdjustmentData"
      header-row-class-name="thead-light"
      empty-text="No scenario has been run or saved.">
      <el-table-column label="Name" min-width="4rem" prop="name">
        <template v-slot="{row}">
          <div class="table-row-name">{{row.name}}</div>
        </template>
      </el-table-column>

      <el-table-column min-width="2rem" label="Adjustment" prop="adjustment">
        <template v-slot="{row}" class="pl-5">
          <div class="pl-2">
            {{row.adjustment}}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </b-card>
</b-col>
</b-row>
</b-container>
</template>
<script>
import { Table, TableColumn } from 'element-ui';
import { mapGetters } from 'vuex';

export default {
  name: 'adjustments-table',
  components: {
    ['ElTable']: Table,
    ['ElTableColumn']: TableColumn,
  },
  computed: {
    ...mapGetters(["getScenario"]),
    getAdjustmentData() {
      const tableData = [];
      for (let adjustment of this.getScenario.adjustments) {
        const adjustmentData = {
          name: adjustment.name,
          adjustment: adjustment.adjustment
        }
        tableData.push(adjustmentData);
      }
      return tableData;
    }
  }

}
</script>

<style>
.el-table .cell {
    padding-left: 0px;
    padding-right: 0px;
    word-break: break-word;
    font-size: 14px;
}

.table-row-name {
    font-weight: 600;
}

.allow-new-lines {
    white-space: pre-line;
}
.label {
    font-size: 15px;
}
</style>
